import { formatEnumOptions } from "@edgetier/client-components";
import { FunctionComponent, memo, useMemo } from "react";

import SelectField from "../select-field";
import { IProps } from "./select-enum.types";

/**
 * Display a select input containing any enum values.
 * @param props.excludeItems Optional list of items to exclude.
 * @param props.name         Form field name.
 * @param props.items        An enum.
 * @param props.otherProps   Props to pass on to inner select component.
 * @returns                  Select component.
 */
const SelectEnum: FunctionComponent<IProps> = ({
    excludeItems,
    getLabel = ({ label }: ReturnType<typeof formatEnumOptions>[0]) => label,
    items,
    name,
    getIcon,
    ...otherProps
}) => {
    const formattedItems = useMemo(() => formatEnumOptions(items, excludeItems), [items, excludeItems]);
    return (
        <SelectField
            description="Select an option"
            getLabel={getLabel}
            getValue={({ value }) => value}
            items={formattedItems}
            name={name}
            getIcon={getIcon}
            {...otherProps}
        />
    );
};

export default memo(SelectEnum);
